import { EPageTypes, EPlatformTypes } from '@cian/frontend-dynamic-calltracking-component';
import { DynamicPhone } from '@cian/frontend-newbuilding-call-component';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { PhonesPreloader } from 'shared/components/PhonesPreloader/PhonesPreloader';
import { useApplicationContext } from 'shared/containers/ApplicationContext';
import { getPhones } from 'shared/selectors';
import { getDynamicCalltrackingSiteBlockId } from 'shared/selectors/getDynamicCalltrackingSiteBlockId';
import { getOfferId } from 'shared/selectors/newObject';
import { formatNumber, getPhoneLink } from 'shared/utils/phone';

export const NewbuildingDynamicPhone = ({ placeType }: { placeType: string }) => {
  const { httpApi, logger } = useApplicationContext();
  const phones = useSelector(getPhones);
  const siteBlockId = useSelector(getDynamicCalltrackingSiteBlockId);
  const offerId = useSelector(getOfferId);

  const formattedPhones = React.useMemo(
    () =>
      phones.map(phone => ({
        number: formatNumber(phone),
        link: getPhoneLink(phone),
      })),
    [phones],
  );

  if (!siteBlockId) {
    return <>{formattedPhones[0].number}</>;
  }

  return (
    <DynamicPhone
      loader={<PhonesPreloader />}
      formattedPhone={formattedPhones[0].number}
      siteBlockId={siteBlockId}
      httpApi={httpApi}
      logger={logger}
      placeType={placeType}
      pageType={EPageTypes.OfferCard}
      platformType={EPlatformTypes.WebDesktop}
      announcementId={offerId}
    />
  );
};
